<template lang="pug">
  el-card(shadow="hover",v-if="processo.id").card-container
    .titulo-analise
      el-menu(default-active="1" mode="horizontal" @select="handleSelect")
          el-menu-item(index="1") Emissão do {{isEstadoMA ? 'Boleto' : 'DAE'}} {{processo.numeroProcesso}}
          el-menu-item(index="2") Análise do Processo
      app-opcoes-header-analise(
        :idProcesso="processo.id"
        :tipoProcesso="processo.tipo.codigo"
        :numeroProcesso="processo.numeroProcesso"
        :protocolo="processo.numeroProtocolo"
        :btnSolicitarInformacao="false"
        :btnRetificacao="false"
      )
    template(
      v-if="step === 1"
    )
      el-steps.mt-20(:active='tela', finish-status='success', align-center, v-if="exibirSteps")
        el-step(
          title='Visualizar DAEs'
          icon="el-icon-view"
          :status='tela > 0 ? "success" : "process"'
          v-if="visualizarDae"
        )
        el-step(
          title='Informar dados do documento',
          :status='tela === 2 ? "success" : "process"'
          icon="el-icon-edit-outline"
          v-if="emitirDae"
        )
        el-step(
          title='Confirmar dados'
          status="process"
          icon="el-icon-tickets"
          v-if="confirmarDados"
        )
      div
        div(v-if="tela === 0")
          app-pagamento(
                  v-if="processo.numeroProcesso"
                  :numeroProcesso="processo.numeroProcesso"
                  :descricao="this.parcela.numeroParcela ? `${this.parcela.numeroParcela} ª Parcela` : `Á vista`"
                  :referenciaParcela="this.parcela.numeroParcela ? this.parcela.numeroParcela : null"
                  :codigoReceita="formatCodigoReceita(this.parcela)"
                  :idBoleto="this.parcela.id"
                  :idProcesso="idProcesso"
                )
        div(v-if="tela === 1")
          validation-observer(ref='validation' tag='form')
            form(@submit.prevent="onSubmit" v-if="dadosInteressado")
              el-row.mb-20(type="flex", :gutter="40")
                el-col(v-if="!isParcelado")
                  validation-provider(rules="notZero", v-slot="{ errors }")
                    app-label(label="Valor Principal:")
                    app-double-input.input(
                      v-model='valorPrincipal',
                      :disable='true'
                      prefix='R$ ',
                      :class="{'erro' : errors.length}"
                      :propId="'label-valorPrincipal'"
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  app-label(label="Valor Multa:")
                  app-double-input.input(
                    :disable='true'
                    v-model='valorMulta'
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Valor Correção Monetária:")
                  app-double-input.input(
                    v-model='valorCorrecao',
                    :disable='true',
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Valor Acréscimos Monetários:")
                  app-double-input.input(
                    v-model='valorAcrescimos',
                    prefix='R$ ',
                    :disable='true'
                  )
                el-col()
                  app-label(label="Valor Total:")
                  app-double-input.input(
                    :value="total()"
                    :disable='true',
                    prefix='R$ '
                  )
              el-row(type="flex", :gutter="40")
                el-col()
                  app-label(label="Data de Vencimento:")
                  el-input.input(
                    v-model='dataVencimento'
                    format="dd/MM/yyyy",
                    disabled
                  )
                el-col()
                  app-label(label="Receita:")
                  el-input.input(
                    v-model='receita'
                    disabled
                  )
                el-col()
                  app-label(label="Data do Cálculo:")
                  el-input.input(
                    :value='dataCalculo',
                    prefix-icon='el-icon-date',
                    disabled
                  )
                el-col()
                  app-label(label="Referência:")
                  el-input.input(
                    :value='referencia',
                    prefix-icon='el-icon-date',
                    disabled
                  )
              app-divider.mb-20(label='')
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  app-label(label="Nome/Razão Social:")
                  el-input.input(
                    :value='dadosInteressado.nomeRazaoSocial',
                    disabled
                  )
                el-col()
                  app-label(label="CPF/CNPJ:")
                  el-input.input(
                    :value='dadosInteressado.cpfCnpj',
                    disabled
                  )
                el-col()
                  app-label(label="Documento de Origem:")
                  el-input.input(
                    :value='processo.numeroProcesso',
                    disabled
                  )
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Município:")
                    el-select.full-width.input(
                    v-model='idMunicipio'
                      :class="{'erro' : errors.length}"
                      @change="pegaNomeMunicipio"
                      :id="'id-municipio'"
                    )
                      el-option(
                        v-for='municipio in municipios'
                        :key='municipio.id',
                        :label='municipio.nome'
                        :value='municipio.id'
                      )
                    span.help.erro {{ errors[0] }}
                    div.mt-20(v-if="isVisualizarMunicipio")
                      a.link(@click="utilizarMunicipio()") Utilizar município do interessado
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Endereço:")
                    el-input.input(
                      v-model='endereco',
                      :value='endereco',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                      :id="'id-endereco'"
                    )
                    span.help.erro {{ errors[0] }}
                    div.mt-20(v-if="isVisualizarMunicipio")
                      a.link(@click='utilizarEndereco()') Utilizar endereço do interessado
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Telefone:")
                    el-input.input(
                      v-model='telefone',
                      :value='telefone',
                      :class="{'erro' : errors.length}"
                      :id="'id-telefone'"
                    )
                    span.help.erro {{ errors[0] }}
                    div.mt-20
                      a.link(@click="utilizarTelefone()") Utilizar telefone do interessado
              el-row
                el-col
                  app-label(
                    label="Informações Adicionais: ",
                    :required='false'
                  )
                  el-input(
                    type='textarea',
                    :rows='5',
                    placeholder='Digite o texto...',
                    v-model='informacoesAdicionais',
                    maxlength='500',
                    show-word-limit
                  )
        div(v-if="tela === 2")
          el-divider
            h3 Dados do documento
          el-row(:gutter="40")
            el-col(:span="8")
              app-display(label="Nome/Razão Social:", :content="dadosInteressado.nomeRazaoSocial")
              app-display(label="CPF/CNPJ:", :content="dadosInteressado.cpfCnpj")
              app-display(label="Endereço:", :content="endereco")
              app-display(label="Município:", :content="municipio")
              app-display(label="Telefone:", :content="telefone")
            el-col(:span="8")
              app-display(label="Documento Origem:", :content="processo.numeroProcesso")
              app-display(label="Receita:", :content="receita")
              app-display(label="Referência:", :content="formataReferencia(receita)")
              app-display(label="Data de Vencimento:", :content="dataVencimento")
              app-display(label="Data do Cálculo:", :content="dataCalculo")
            el-col(:span="8")
              app-display(label="Valor Principal:", :content="formatValor(valorPrincipal)")
              app-display(label="Valor Multa:", :content="formatValor(valorMulta)")
              app-display(label="Valor Correção Monetária:", :content="formatValor(valorCorrecao)")
              app-display(label="Valor Acréscimos Monetários:", :content="formatValor(valorAcrescimos)")
              app-display(label="Valor Total:", :content="formatValor(valorTotal)")
              app-display(label="Informações Adicionais:", :content="informacoesAdicionais")
      app-buttons-cadastro(
        :isPrimeiroPasso='isPrimeiroPasso',
        :isUltimoPasso='tela === 2'
        @cancelar='cancelar',
        @proximo='proximo',
        @voltar='voltar',
        @finalizar='finaliza',
        :showButtonCancelar='showButton',
        :showButtonProximo='showButton',
      )
    template(
      v-if="step === 2 && dadosCadastro"
    )
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastro.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
        )
</template>

<script>
import FileSaver from 'file-saver'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppDoubleInput from '@/components/AppDoubleInput'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import AppOpcoesHeaderAnalise from './components//modal/AppOpcoesHeaderAnalise'
import AppPagamento from '@/components/AppPagamentoGestaoVtn'
import AppPagamentoMa from '@/components/AppPagamentoMa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDespachos from '@/components/AppDespachos'
import axios from '@/utils/api'

export default {
  components: {
    AppLabel,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro,
    AppDoubleInput,
    AppOpcoesHeaderAnalise,
    AppPagamento,
    AppPagamentoMa,
    AppDespachos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      tela: 1,
      formaPagamento: this.isEstadoMAOrRR ? 'A_VISTA' : null,
      passo1: true,
      ultimoPasso: false,
      valorPrincipal: 0,
      valorMulta: 0,
      valorCorrecao: 0,
      valorAcrescimos: 0,
      valorTotal: 0,
      valorTotalBoleto: 0,
      valorDesconto: 0,
      valorLiquido: 0,
      parcelaSelecionada: null,
      dataEmissao: new Date(),
      dataVencimentoPreDefinida: null,
      dataVencimento: null,
      municipio: null,
      pegarMunicipio: null,
      municipios: null,
      endereco: '',
      telefone: '',
      idMunicipio: null,
      informacoesAdicionais: '',
      dadosInteressado: null,
      dadosCadastro: null,
      step: 1,
      processo: {
        numeroProcesso: null,
        numeroProtocolo: null
      },
      isEdicao: false,
      idBoletoEdicao: null,
      isVisualizarMunicipio: false,
      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      vtn: {}
    }
  },
  props: {
    idProcesso: {
      required: true
    },
    emitirDae: {
      required: false,
      default: true
    },
    confirmarDados: {
      required: false,
      default: true
    },
    visualizarDae: {
      required: false,
      default: true
    },
    parcela: {
      required: false
    },
    isVencida: {
      type: Boolean,
      required: false,
      default: false
    }

  },
  async mounted () {
    this.dadosInteressado = await this.processoPessoa(this.idProcesso)
    const processo = await this.getProcessoById(this.idProcesso)
    this.processo = processo
    const data = await this.getVtn(this.idProcesso)
    this.vtn = data
    this.municipios = await this.findByCodigoEstado(process.env.ESTADO.toUpperCase()) || []
    this.isVisualizarMunicipio = !!this.municipios.find(m => m.id === this.dadosInteressado.endereco.municipio.id)
    this.valorPrincipal = this.parcela.valorPrincipal ? this.parcela.valorPrincipal : this.parcela.valor
    if (!this.parcela.valorPrincipal) {
      this.parcela.valorPrincipal = this.valorPrincipal
    }
    const parcelaVtn = await this.getMultaJuros({
      boleto: this.parcela,
      idVtn: this.vtn.id,
      isVencida: this.isVencida
    })
    this.valorCorrecao = parcelaVtn.valorCorrecao
    this.valorMulta = parcelaVtn.valorMulta
    this.valorTotalBoleto = parcelaVtn.valorTotal
    this.valorPrincipal = parcelaVtn.valorPrincipal
    this.valorAcrescimos = parcelaVtn.valorAcrescimos
    this.dataVencimento = this.getDataVencimento()

    this.tela1()
    this.getDataVencimentoPreDefinida()
  },
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    isEstadoMAOrRR () {
      return process.env.ESTADO === 'ma' || process.env.ESTADO === 'rr'
    },
    isEstadoRR () {
      return process.env.ESTADO === 'rr'
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoPA () {
      return process.env.ESTADO === 'pa'
    },
    exibirSteps () {
      if (this.isEstadoMAOrRR && (this.processo.status !== 'AGUARDANDO_BOLETO') && !this.isEdicao) {
        return false
      }
      return true
    },
    dataCalculo () {
      return moment(new Date()).format('DD/MM/YYYY')
    },
    referencia () {
      return moment(new Date()).format('MM/YYYY')
    },
    isPrimeiroPasso () {
      if (this.visualizarDae) {
        return false
      } else if (this.tela === 1) {
        return true
      }
      return false
    },
    receita () {
      return this.parcela.receita?.tipoReceita?.descricao || 'RECEITA DE VALOR DA TERRA NUA-VTN/ITERPA 5803-3'
    },
    isParcelado () {
      return this.formaPagamento === 'PARCELADO'
    },
    parcelas () {
      return [2, 3, 4, 5]
    },
    exibirTabelaParcelas () {
      return this.isParcelado && this.parcelaSelecionada && this.valorPrincipal !== 0
    },
    parcelasTabela () {
      var linhasParcelas = [{
        parcela: 'Entrada',
        valor: this.formatValor(this.valorPrincipal * 0.2),
        dataVencimento: this.formatData(new Date())
      }]

      var parcelaAtual = ((this.valorPrincipal - (this.valorPrincipal * 0.2)) / (this.parcelaSelecionada - 1)) * 1.12
      var juros = ((this.valorPrincipal - (this.valorPrincipal * 0.2)) / (this.parcelaSelecionada - 1)) * 0.12
      var valorFinal = this.valorPrincipal * 0.2

      for (let index = 1; index < this.parcelaSelecionada; index++) {
        linhasParcelas = [...linhasParcelas, {
          parcela: `${index}ª Parcela`,
          valor: this.formatValor(parcelaAtual),
          dataVencimento: this.formatData(this.setDataVencimentoParcelas(index))
        }]
        valorFinal += parcelaAtual
        parcelaAtual += juros
      }

      this.setValorTotalParcelado(valorFinal)

      linhasParcelas = [...linhasParcelas, {
        parcela: 'Total',
        valor: this.formatValor(valorFinal),
        dataVencimento: ''
      }]

      return linhasParcelas
    },
    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    showButton () {
      return !this.visualizarDae
    }
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      finalizar: 'analiseDae/finalisar',
      emitirDaePorParcela: 'dae/emitirDaePorParcelaDoVtn',
      remitirDaeVencida: 'dae/reemitirDaeVencida',
      getMultaJuros: 'dae/jurosDae',
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      findByCodigoEstado: 'dae/findByCodigoEstado',
      processoPessoa: 'dae/processoPessoa',
      iniciaAnalise: 'processo/iniciaAnalise',
      reemitirDae: 'dae/reemitirDae',
      updateDae: 'dae/updateDae',
      getValorBoleto: 'dae/getValorBoleto',
      getVtn: 'vtn/getVtnProcessoId',
      getParcelas: 'vtn/getParcelas'
    }),
    async tela1 () {
      this.tela = this.visualizarDae ? 0 : 1
    },
    setRadio (tipo) {
      this.formaPagamento = tipo
      this.valorDesconto = 0
      this.parcelaSelecionada = null
    },
    formataReferencia (value) {
      if (this.parcela.numeroParcela) {
        if (value) {
          return `${value} (referente a ${this.parcela.numeroParcela}° parcela)`
        }
        return `RECEITA DE VALOR DA TERRA NUA-VTN/ITERPA 5803-3 (referente a ${this.parcela.numeroParcela}° parcela)`
      }
      return value
    },
    getDataVencimentoPreDefinida () {
      const date = new Date()
      this.dataVencimentoPreDefinida = new Date()
      this.dataVencimentoPreDefinida.setDate(date.getDate() + 30)
    },
    setDataVencimentoParcelas (index) {
      const date = new Date()
      var dataVencimentoParcela = new Date()
      dataVencimentoParcela.setFullYear(date.getFullYear() + index)
      return dataVencimentoParcela
    },
    setValorTotalParcelado (valor) {
      this.valorTotal = valor
    },
    pegaNomeMunicipio () {
      if (this.isEstadoMAOrRR) {
        this.municipio = this.dadosInteressado.endereco.municipio.nome
        return
      }
      if (this.municipios) this.municipio = this.municipios.filter(municipio => municipio.id === this.idMunicipio)[0].nome
    },
    async handleSelect (index) {
      if (parseInt(index) === this.step) {
        return
      }
      if (this.step === 1) {
        this.step = 2
        this.dadosCadastro = await this.iniciaAnalise({idProcesso: this.idProcesso, tipoAcao: 'DAE'})
      } else {
        this.step = 1
        this.dadosCadastro = null
      }
    },
    total () {
      this.valorTotal = this.valorTotalBoleto + this.valorAcrescimos
      return this.valorTotal
    },
    async utilizarEndereco () {
      this.endereco = `${this.dadosInteressado.endereco.logradouro}, ${this.dadosInteressado.endereco.numero ? this.dadosInteressado.endereco.numero : 'sem número'}, ${this.dadosInteressado.endereco.complemento ? (this.dadosInteressado.endereco.complemento + ',') : ''} ${this.dadosInteressado.endereco.bairro}`
    },
    async utilizarTelefone () {
      this.telefone = this.dadosInteressado.telefones[0].numero
    },
    utilizarMunicipio () {
      this.idMunicipio = this.dadosInteressado.endereco.municipio.id
      this.pegaNomeMunicipio()
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    cancelar () {
      this.isEdicao = false
      this.$router.back()
    },
    async proximo () {
      if (this.tela === 1 && !await this.checkValidacao()) {
        return
      }
      this.tela++
      this.passo1 = false
    },
    voltar () {
      if (this.visualizarDae) {
        this.isEdicao = false
        this.$router.back()
      }
      if (this.tela === 1) this.isEdicao = false
      this.tela--
    },
    formatValor (valor) {
      if (!valor) valor = 0
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formatCodigoReceita (prop) {
      if (prop.receita) {
        return this.parcela.receita.tipoReceita.codigo
      } else {
        return '5803'
      }
    },

    finaliza () {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          // const ref = moment(new Date()).format('YYYYMM')
          let boleto
          if (this.isEdicao) {
            boleto = {
              id: this.idBoletoEdicao,
              isParcelado: this.isParcelado,
              valorTotal: this.valorPrincipal,
              valorDesconto: this.valorDesconto
            }
            this.updateDae(boleto).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
              this.$router.push({
                name: 'DAE'
              })
            }).catch((error) => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
          } else {
            this.parcela = {
              ...this.parcela,
              vtn: {id: this.vtn.id},
              numeroParcela: this.parcela.numeroParcela,
              valorAcrescimos: this.valorAcrescimos,
              valorCorrecao: this.valorCorrecao,
              valorMulta: this.valorMulta,
              valorTotal: this.valorTotal
            }
            if (this.isEstadoPA) {
              if (this.parcela.situacao !== 'VENCIDO' && !this.parcela.existeBoleto) {
                this.emitirDaePorParcela({
                  parcelaVtn: this.parcela,
                  isVencida: this.isVencida
                }).then(() => {
                  this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                    this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
                  this.$router.push({
                    name: 'VISUALIZAR_DAES_COF'
                  })
                }).catch((error) => {
                  this.showNotificacao(
                    this.$messages.TIPO_ERROR,
                    this.$messages.TITULO_ERROR,
                    error.message
                  )
                })
              } else {
                this.remitirDaeVencida({
                  parcelaVtn: this.parcela,
                  isVencida: this.isVencida
                }).then(() => {
                  this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                    this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
                  this.$router.push({
                    name: 'VISUALIZAR_DAES_COF'
                  })
                }).catch((error) => {
                  this.showNotificacao(
                    this.$messages.TIPO_ERROR,
                    this.$messages.TITULO_ERROR,
                    error.message
                  )
                })
              }
            } else {
              this.emitirDaePorParcela({
                parcelaVtn: this.parcela,
                isVencida: this.isVencida
              }).then(() => {
                this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                  this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
                this.$router.push({
                  name: 'VISUALIZAR_DAES_COF'
                })
              }).catch((error) => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  error.message
                )
              })
            }
          }
        },
        () => {})
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    reemitirBoleto ({ id }) {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          this.reemitirDae(id).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
            this.$router.push({
              name: 'DAE'
            })
          }).catch((error) => {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              error.message
            )
          })
        },
        () => {})
    },
    editarDae (boleto) {
      this.idBoletoEdicao = boleto.id
      this.isEdicao = true
      this.valorPrincipal = boleto.valorPrincipal
      this.formaPagamento = boleto.isParcelado ? 'PARCELADO' : 'A_VISTA'
      this.valorDesconto = boleto.desconto ? boleto.desconto : 0
      this.proximo()
    },

    getDataVencimento () {
      const dataAtual = moment()
      const dataVencimento = dataAtual.add(30, 'days')

      return dataVencimento.format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.medium-margin-top {
  margin-top: 20px;
}

.small-margin-top {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.margin-btn {
  width: 16px;
  height: 25px;
  margin-bottom: 20px;
}

.justify {
  justify-content: space-between;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
}

.disabled {
  background-color: #f5f7fa;
  color: #c8c5d3;
  cursor: not-allowed;
}

.full-width {
  width: -webkit-fill-available;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-40 {
  margin-bottom: 40px;
}
.el-input__prefix {
  margin-top: 12px;
}

.link {
  cursor: pointer;
  color: #009f61;
  &:hover {
    font-weight: bold;
  }
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

>>> .el-table__row {
  &:last-child {
    font-weight: bold;
  }
}

.select-erro {
  border: 1px solid #b22222;
  border-radius: 4px;
  border-color: #b22222;
  -webkit-box-shadow: inset 0 1px 2px #ff867c, 0 0 9px #b22222;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/EmitirDaeParcela.vue